var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "pt-20 pb-20" },
    [
      _c("div", { staticClass: "success-content" }, [
        _c("div", { staticClass: "success-icon" }),
        _vm._v(" "),
        _vm.boleto
          ? _c("h2", [_vm._v("SEU BOLETO ESTÁ PRONTO!")])
          : _c("h2", [_vm._v("SUA LIMPEZA FOI AGENDADA COM SUCESSO!")])
      ]),
      _vm._v(" "),
      _vm.showBoletoWarning
        ? _c("div", { staticClass: "boleto-warning" }, [
            _c("h4", [_vm._v("VOCÊ PRECISA ENVIAR O COMPROVANTE")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n      Para que a limpeza não seja cancelada,\n      "),
              _c(
                "b",
                { staticClass: "pointer", on: { click: _vm.openSupport } },
                [_vm._v("clique aqui")]
              ),
              _vm._v(
                " e envie o comprovante de pagamento com até 48h úteis antes da limpeza.\n    "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.boleto ? _c("boleto", { attrs: { boleto: _vm.boleto } }) : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn bg-pink mt-20",
              attrs: {
                to: {
                  name: _vm.singularPayableType(),
                  params: { id: _vm.payable.id }
                }
              }
            },
            [_vm._v(_vm._s(_vm.buttonText()))]
          ),
          _vm._v(" "),
          _vm.payable.type === "orders"
            ? _c("p", [
                _vm._v(
                  "\n      O profissional acaba de ser notificado sobre esta nova limpeza. O seu pagamento ficará retido no\n      meio de pagamnento e só será enviado ao profissional após a limpeza. Caso o profissional cancele, você pode solicitar o reagendamento ou o reembolso.\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          this.payable.type === "orders"
            ? _c(
                "div",
                { staticClass: "subscription" },
                [
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "sub-loader" },
                        [
                          _c("Loader"),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Enviando solicitação para o nosso time de atendimento..."
                            )
                          ])
                        ],
                        1
                      )
                    : _vm.success
                      ? [
                          _c("h4", [
                            _vm._v(
                              "Tudo certo! Nosso time de atendimento ao cliente recebeu a sua solicitação e em breve entrará em contato para acertar os detalhes e confirmar a sua assinatura."
                            )
                          ])
                        ]
                      : [
                          _c("h4", [
                            _vm._v(
                              "\n          Deixe suas limpezas programadas e viva a experiência do seu espaço sempre limpinho!\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.error
                            ? [
                                _c("p", [
                                  _vm._v(
                                    "Ops. Não foi possível criar a solicitação com o nosso time de atenditmento. Tente novamente ou entre em contato se o problema persistir"
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn bg-purple btn-sub",
                              on: {
                                click: function($event) {
                                  _vm.requestSubscription("Mensal")
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v("Quero repetir essa limpeza todo mês")
                              ]),
                              _vm._v(" "),
                              _vm._m(0)
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn bg-purple btn-sub",
                              on: {
                                click: function($event) {
                                  _vm.requestSubscription("Quinzenal")
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Quero repetir essa limpeza a cada duas semanas"
                                )
                              ]),
                              _vm._v(" "),
                              _vm._m(1)
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn bg-purple btn-sub",
                              on: {
                                click: function($event) {
                                  _vm.requestSubscription("Semanal")
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v("Quero repetir essa limpeza toda semana")
                              ]),
                              _vm._v(" "),
                              _vm._m(2)
                            ]
                          ),
                          _vm._v(" "),
                          _vm.payable.type === "orders"
                            ? _c("p", [
                                _vm._v(
                                  "\n          Com a assinatura Donamaid você não precisa mais se preocupar em agendar as suas limpezas. A sua limpeza com o seu profissional favorito é gerada automaticamente na frequência e horário da sua preferência.\n        "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.payable.type === "orders"
                            ? _c("p", [
                                _vm._v(
                                  "\n          Essa super comodidade para o seu dia a dia ainda vem com ainda mais benefícios: um super desconto fixo para todas as suas limpezas de assinatura. Você não vai perder essa, né?\n        "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.payable.type === "orders"
                            ? _c("p", [
                                _vm._v(
                                  "\n          Os planos não possuem fidelidade, então se precisar alterar o plano ou cancelar é super rápido e fácil.\n        "
                                )
                              ])
                            : _vm._e()
                        ]
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("FAQ", { attrs: { rules: _vm.payable.type === "orders" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "discount" }, [
      _vm._v("Economize até "),
      _c("b", [_vm._v("R$ 72,00")]),
      _vm._v(" em um ano")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "discount" }, [
      _vm._v("Economize até "),
      _c("b", [_vm._v("R$ 208,00")]),
      _vm._v(" em um ano")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "discount" }, [
      _vm._v("Economize até "),
      _c("b", [_vm._v("R$ 520,00")]),
      _vm._v(" em um ano")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-951f4a56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-951f4a56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Success.vue
// module id = null
// module chunks = 